import { StringUtil } from '@nomidio/common';

export enum DomainVerificationType {
  Dns = 'DNS',
  Manual = 'MANUAL',
}

export function DomainVerificationTypePresentation(type: DomainVerificationType): string {
  switch (type) {
    case DomainVerificationType.Dns:
      return 'DNS Verification (recommended)';
    case DomainVerificationType.Manual:
      return 'Email Verification';
    default:
      console.warn(`Mapping not handled for type '${type}' falling back to value`);
      return StringUtil.toPresentationFormat(type);
  }
}
